export enum TicketAction {
    Invite = 'Kviesti',
    Continue = 'Tęsti',
    Remove = 'Pašalinti',
    Send = 'Siųsti'
}
